import { Grid, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { KCenteredContentBox } from 'components/core/KCenteredContentBox'
import { ApplePayStep1, ApplePayStep2, ApplePayStep3 } from 'components/images'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const ApplePaySteps = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <Grid
      container
      sx={{
        marginX: 'auto',
        alignSelf: 'center',
        maxWidth: 720,
        [theme.breakpoints.up('md')]: {
          alignSelf: 'start',
        },
      }}
    >
      <Grid xs={4}>
        <ApplePayStep
          step={1}
          prompt={t('Submit your order')}
          icon={<ApplePayStep1 />}
        />
      </Grid>
      <Grid xs={4}>
        <ApplePayStep
          step={2}
          prompt={t('Scan the QR code')}
          icon={<ApplePayStep2 />}
        />
      </Grid>
      <Grid xs={4}>
        <ApplePayStep
          step={3}
          prompt={t('Pay on your Apple device')}
          icon={<ApplePayStep3 />}
        />
      </Grid>
    </Grid>
  )
}

// const ApplePaySep = styled(Box)(({ theme }) => ({
//   width: 40,
//   height: '1px',
//   backgroundColor: theme.palette.text.primary,
// }))

const ApplePayStep = ({
  step,
  prompt,
  icon,
}: {
  step: number
  prompt: string
  icon: ReactNode
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <Stack
      sx={{
        alignItems: 'center',
        textAlign: 'center',
        gap: 2,
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
      }}
    >
      <Typography variant="body2">{t('Step {{step}}', { step })}</Typography>
      <KCenteredContentBox
        sx={{
          height: 136,
          width: 136,
          border: '1px solid',
          borderColor: theme.palette.grey['400'],
          borderRadius: 4,
          [theme.breakpoints.down('md')]: {
            height: 100,
            width: 100,
            '& svg': {
              height: 64,
            },
          },
          [theme.breakpoints.down('sm')]: {
            height: 64,
            width: 64,
            '& svg': {
              height: 48,
            },
          },
        }}
      >
        {icon}
      </KCenteredContentBox>
      <Typography variant="h5">{prompt}</Typography>
    </Stack>
  )
}
